// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { kakarotSepolia as _kakarotSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the kakarotSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1802203764
 * Chain Name: Kakarot Sepolia
 * Default Block Explorer: https://sepolia.kakarotscan.org
 * Default RPC URL: https://sepolia-rpc.kakarot.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { kakarotSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: kakarotSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const kakarotSepolia = createCommon({
	..._kakarotSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
